export default __webpack_public_path__ + "eb58ece97f06e1983d1cd487f2b49506.png";